import styled from 'styled-components';

export const HistoryContainer = styled.div`
  max-width: 98%;
`;

export const HistoryTitle = styled.h3`
  font-size: 18px;
  color: #333;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ddd;
`;

export const ThreadContainer = styled.div`
  //   max-height: 400px;
  //   overflow-y: auto;
  padding-right: 10px;

  //   &::-webkit-scrollbar {
  //     width: 6px;
  //   }

  //   &::-webkit-scrollbar-track {
  //     background: #f1f1f1;
  //   }

  //   &::-webkit-scrollbar-thumb {
  //     background: #ccc;
  //     border-radius: 10px;
  //   }

  //   &::-webkit-scrollbar-thumb:hover {
  //     background: #999;
  //   }
`;

export const ThreadItem = styled.div`
  margin-bottom: 5px;
  padding-bottom: 5px;
`;

export const UserQuestion = styled.div`
  margin-bottom: 12px;
  padding: 10px;
  border-radius: 6px;
  background-color: #e3f2fd;
`;

export const AIText = styled.div`
  margin-bottom: 12px;
  padding: 10px;
`;

export const UserText = styled.div`
  margin-bottom: 12px;
  padding: 10px;
  border-radius: 6px;
  background-color: var(--ds-bg-secondary);
`;

export const ContentHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-weight: 500;
  color: #555;
`;

export const ContentIcon = styled.span`
  margin-right: 8px;
  font-size: 16px;
`;

export const ContentLabel = styled.span``;

export const ContentBody = styled.div`
  color: #333;
  line-height: 1.5;
  white-space: pre-wrap;
`;

export const Timestamp = styled.div`
  font-size: 12px;
  color: #888;
  text-align: right;
  margin-top: 8px;
`;
